export default {
  getLoading(state) {
    return state.isLoading;
  },
};
